import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright 2022 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import * as React from 'react';
import { View } from "../view";
import { useControlledValue } from "../../hooks/_private/useControlledValue";
import { AccordionGroupContext } from './AccordionGroup.context';
export const AccordionGroup = ({ allowMultipleOpenItems = true, children, defaultOpenItems, disabled, openAccordionNames, variant = 'list', onGroupChange, }) => {
    const [controlledOpenAccordionNames, setControlledOpenAccordionNames] = useControlledValue({
        defaultValue: defaultOpenItems,
        value: openAccordionNames,
        onValueChange: onGroupChange,
    }, []);
    if (!allowMultipleOpenItems && (defaultOpenItems || []).length > 1) {
        throw new Error("You cannot specify more than one of AccordionGroup's children Accordions to be open by default with 'allowMultipleOpenItems' set to false.");
    }
    const handleGroupChange = React.useCallback((updatedOpenAccordionNames) => {
        if (allowMultipleOpenItems || updatedOpenAccordionNames.length < 2) {
            setControlledOpenAccordionNames(updatedOpenAccordionNames);
        }
        else {
            const updatedActiveAccordionId = updatedOpenAccordionNames[updatedOpenAccordionNames.length - 1];
            setControlledOpenAccordionNames([updatedActiveAccordionId]);
        }
    }, [allowMultipleOpenItems, setControlledOpenAccordionNames]);
    const value = React.useMemo(() => ({
        disabled,
        variant,
        openAccordionNames: controlledOpenAccordionNames,
        onGroupChange: openAccordionNames ? setControlledOpenAccordionNames : handleGroupChange,
    }), [
        controlledOpenAccordionNames,
        disabled,
        handleGroupChange,
        openAccordionNames,
        setControlledOpenAccordionNames,
        variant,
    ]);
    return (_jsx(View, { direction: "column", attributes: { 'data-testid': 'st-accordion-group' }, children: _jsx(AccordionGroupContext.Provider, { value: value, children: children }) }));
};
